import { render, staticRenderFns } from "./waiting-tab.vue?vue&type=template&id=27679e89"
import script from "./waiting-tab.vue?vue&type=script&lang=js"
export * from "./waiting-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports